class CapacityControlButtonsController {
    constructor(CapacityServiceApi, TraceHubExService, UserDetailsApi, $routeParams, toastr, ModalService, SettingsService) {
        this.traceHubComponentName = 'CapacityTesterStartstopController';
        this.$onInit = () => {
            this.init();
        };
        this.$onDestroy = () => {
            this.TraceHubExService.stop(this.traceHubComponentName);
        };
        this.init = () => {
            this.setButtonStatus();
            this.SettingsService.getSettings().then((response) => {
                const appSettings = response.data;
                this.TraceHubExService.connectWithSpecificTransport(this.traceHubComponentName, appSettings.SignalRTransport);
                this.TraceHubExService.on(this.traceHubComponentName, 'onInit', (connId) => {
                    this.connectionId = connId;
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onCapacitySimInstanceChange', (e) => {
                    if (e.CapacitySim.SessionId !== this.capacitySim.SessionId || e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    this.capacitySim = e.CapacitySim;
                    this.setButtonStatus();
                });
                this.TraceHubExService.on(this.traceHubComponentName, 'onCapacitySessionCleared', (e) => {
                    if (e.CapacitySim.SessionId !== this.capacitySim.SessionId || e.ConnectionId !== this.connectionId) {
                        return;
                    }
                    if (e.RequestingUserIdPId && e.RequestingUserIdPId !== this.userDetails.SingleSignOnDetails.IdPID) {
                        let modalOptions = {
                            actionButtonText: 'Ok',
                            okOnly: true,
                            headerText: 'Test Data Cleared',
                            bodyText: 'All test data for this session has been cleared by ' + e.RequestingUserIdPDisplayName
                        };
                        this.ModalService.showModal({}, modalOptions).then(() => { });
                    }
                    this.capacitySim = e.CapacitySim;
                    this.setButtonStatus();
                });
            });
            this.UserDetailsApi.get().then((response) => {
                let connectedUser = response.data;
                this.userDetails = connectedUser;
                this.setButtonStatus();
            }, () => {
                this.toastr.error('Please make sure that you are logged in to web application');
            });
        };
        this.setButtonStatus = () => {
            this.disableAllButtons();
            this.clearDisabled = false;
            // Always keep everything disabled when read only
            if (this.readOnly) {
                return;
            }
            if (_.isNil(this.capacitySim) || _.isEmpty(this.capacitySim)) {
                // No simulator defined. This might just be because it's not been started or has an error. Just leave here and let the signalR update handle it if this changes
                return;
            }
            if (_.isNil(this.capacitySim.SessionId)) {
                this.toastr.error('Simulator does not have a valid session ID');
                return;
            }
            let nonSSO = _.isNil(this.capacitySim.IdPId) || this.capacitySim.IdPId === '';
            // If we have a SSO ID then verify, otherwise we're not using SSO so just let it through
            let isValidSSO = !_.isNil(this.capacitySim.IdPId)
                && this.capacitySim.IdPId !== ''
                && !_.isNil(this.userDetails)
                && this.capacitySim.IdPId === this.userDetails.SingleSignOnDetails.IdPID;
            if (nonSSO || isValidSSO) {
                switch (this.capacitySim.Status.toUpperCase()) {
                    case 'TESTING':
                        this.runDisabled = true;
                        this.pauseDisabled = false;
                        this.clearDisabled = true;
                        break;
                    case 'ERROR':
                    case 'STARTED':
                    case 'PAUSED':
                        this.runDisabled = !this.capacitySim.Connected;
                        this.pauseDisabled = true;
                        this.clearDisabled = false;
                        break;
                }
            }
        };
        this.disableAllButtons = () => {
            this.runDisabled = true;
            this.pauseDisabled = true;
            this.clearDisabled = true;
        };
        this.runSession = () => {
            // Disable all buttons to stop multiple requests from the user. The UI will be updated when the SignalR status event comes back
            this.disableAllButtons();
            this.CapacityServiceApi.run(this.capacitySim.SessionId, this.targetTps).then((response) => {
                // let success: boolean = response.data;
                // TODO ADM Do anything here?
            });
        };
        this.pauseSession = () => {
            // Disable all buttons to stop multiple requests from the user. The UI will be updated when the SignalR status event comes back
            this.disableAllButtons();
            this.CapacityServiceApi.pause(this.capacitySim.SessionId).then((response) => {
                // let success: boolean = response.data;
                // TODO ADM Do anything here?
            });
        };
        this.clearSession = () => {
            let modalOptions = {
                actionButtonText: 'Clear',
                closeButtonText: 'Cancel',
                headerText: 'Clear Test Data',
                bodyText: 'This will clear all test data for this session, are you sure?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                // Disable all buttons to stop multiple requests from the user. The UI will be updated when the SignalR status event comes back
                this.disableAllButtons();
                this.CapacityServiceApi.clear(this.capacitySim.SessionId, this.userId).then((response) => {
                    // let success: boolean = response.data;
                    // TODO ADM Do anything here?
                    this.setButtonStatus();
                });
            });
        };
        this.CapacityServiceApi = CapacityServiceApi;
        this.TraceHubExService = TraceHubExService;
        this.UserDetailsApi = UserDetailsApi;
        this.toastr = toastr;
        this.routeParamService = $routeParams;
        this.ModalService = ModalService;
        this.SettingsService = SettingsService;
    }
}
angular.module('app').component('capacityControlButtons', {
    bindings: {
        capacitySim: '<',
        readOnly: '<',
        targetTps: '<',
        userId: '<',
    },
    controllerAs: 'vm',
    controller: CapacityControlButtonsController,
    templateUrl: 'scripts/app/partials/Capacity/capacity-control-buttons.tpl.html'
});
